import { useNavigate, Link } from "react-router";
import { Container } from "@/shared/components/layout/Container";
import { Section } from "@/shared/components/layout/Section";
import { useCreateContact } from "@/shared/lib/contacts";
import { useAddListMembers } from "@/shared/lib/lists";
import { useActiveScope, useScopedHref } from "@/shared/lib/scope";
import { ContactForm } from "./ContactForm";

export function ContactNew() {
  const navigate = useNavigate();
  const { listId, list } = useActiveScope();
  const href = useScopedHref();
  const create = useCreateContact();
  // The empty-string fallback is fine: we only call mutate when listId is
  // truthy, so the request URL is never built with "".
  const addToList = useAddListMembers(listId ?? "");

  return (
    <Section spacing="md">
      <Container size="4xl">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-2">
            <Link
              to={href("/app/contacts")}
              className="type-label-sm tracking-wider uppercase text-text-muted hover:text-text"
            >
              ← Back to contacts
            </Link>
            <h1 className="type-heading-lg text-text">New contact</h1>
            {list ? (
              <p className="type-body-sm text-text-muted">
                Will be added to <span className="text-text">{list.name}</span>
              </p>
            ) : null}
          </div>
          <ContactForm
            mode="create"
            submitLabel="Create contact"
            pending={create.isPending || addToList.isPending}
            error={create.error ?? addToList.error}
            onSubmit={(input) =>
              create.mutate(input, {
                onSuccess: (contact) => {
                  if (listId) {
                    addToList.mutate(
                      { members: [{ contactId: contact.id }] },
                      {
                        onSuccess: () =>
                          navigate(href(`/app/contacts/${contact.id}`)),
                      },
                    );
                  } else {
                    navigate(`/app/contacts/${contact.id}`);
                  }
                },
              })
            }
          />
        </div>
      </Container>
    </Section>
  );
}
